import React, { ReactNode } from "react";
import { Box, alpha } from "@mui/material";

type Props = {
  impacted: boolean;
  children: ReactNode;
};

/**
 * Outlines a form field whose value feeds the incentive calculation once the admin has
 * changed it (SDCP-1305), so it is obvious which edits made the stored amount stale.
 *
 * The wrapper is always rendered — only its styling reacts to `impacted` — so toggling the
 * highlight never remounts the input underneath and steals focus mid-typing.
 */
const IncentiveImpactHighlight = ({ impacted, children }: Props) => (
  <Box
    data-testid={impacted ? "incentive-impacted-field" : undefined}
    sx={{
      borderRadius: "8px",
      padding: "8px",
      marginTop: "-8px",
      marginBottom: "-8px",
      border: "1px solid",
      borderColor: impacted ? "warning.main" : "transparent",
      backgroundColor: (theme) =>
        impacted ? alpha(theme.palette.warning.main, 0.08) : "transparent",
      transition: "border-color 150ms ease, background-color 150ms ease",
    }}
  >
    {children}
  </Box>
);

export default IncentiveImpactHighlight;
